import { ChangeDetectionStrategy, Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseCtrlValueAccessorFormComponent } from '@sim/form';

import { cardS } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MifFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MifFormComponent),
    },
  ],
  selector: 'app-mif-form',
  styleUrls: ['./mif-form.component.scss'],
  templateUrl: './mif-form.component.html',
})
export class MifFormComponent extends BaseCtrlValueAccessorFormComponent<cardS.MIF> implements OnDestroy, OnInit {
  constructor(
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
